function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M36.598 30.0834C35.3912 33.3541 33.5661 36.1981 31.1726 38.5353C28.4482 41.1957 24.8808 43.3096 20.5694 44.8175C20.4279 44.8669 20.2803 44.9073 20.1319 44.9371C19.936 44.9758 19.7366 44.9967 19.539 44.9994H19.5003C19.2896 44.9994 19.0779 44.9782 18.8679 44.9371C18.7196 44.9073 18.574 44.8669 18.4332 44.8186C14.1166 43.313 10.5448 41.2001 7.81764 38.5398C5.42316 36.2025 3.59835 33.3603 2.39323 30.0896C0.201882 24.1427 0.326573 17.5917 0.426943 12.3272L0.428656 12.2464C0.448867 11.8117 0.461884 11.355 0.469078 10.8508C0.505731 8.37512 2.47407 6.32696 4.95009 6.18891C10.1124 5.90081 14.106 4.21714 17.5182 0.891238L17.548 0.863834C18.1146 0.344172 18.8285 0.0893086 19.539 0.099928C20.2241 0.108835 20.9065 0.363355 21.4528 0.863834L21.482 0.891238C24.8949 4.21714 28.8884 5.90081 34.0508 6.18891C36.5268 6.32696 38.4951 8.37512 38.5318 10.8508C38.539 11.3585 38.552 11.8144 38.5722 12.2464L38.5732 12.2806C38.6733 17.555 38.7973 24.1191 36.598 30.0834Z",
  fill: "#6E98E7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5981 30.0831C35.3913 33.3538 33.5661 36.1977 31.1727 38.535C28.4483 41.1953 24.8809 43.3093 20.5695 44.8172C20.428 44.8665 20.2804 44.907 20.132 44.9368C19.9361 44.9755 19.7367 44.9964 19.5391 44.9991V0.0996094C20.2242 0.108516 20.9066 0.363037 21.4529 0.863515L21.4821 0.89092C24.895 4.21682 28.8885 5.9005 34.0509 6.18859C36.5269 6.32664 38.4952 8.3748 38.5319 10.8505C38.5391 11.3581 38.5521 11.8141 38.5723 12.2461L38.5733 12.2803C38.6734 17.5547 38.7974 24.1188 36.5981 30.0831Z",
  fill: "#0041BE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6897 22.5494C30.6897 28.7062 25.6907 33.7178 19.5391 33.7398H19.4997C13.3299 33.7398 8.30933 28.7196 8.30933 22.5494C8.30933 16.3796 13.3299 11.3594 19.4997 11.3594H19.5391C25.6907 11.3813 30.6897 16.3929 30.6897 22.5494Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6897 22.5494C30.6897 28.7062 25.6907 33.7178 19.5391 33.7398V11.3594C25.6907 11.3813 30.6897 16.3929 30.6897 22.5494Z",
  fill: "#E1EBF0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5787 20.9384L19.539 25.9788L18.45 27.0678C18.1928 27.3251 17.8553 27.4536 17.5183 27.4536C17.1808 27.4536 16.8438 27.3251 16.5862 27.0678L14.2448 24.7254C13.7303 24.2109 13.7303 23.3775 14.2448 22.8626C14.7586 22.3481 15.5931 22.3481 16.1076 22.8626L17.5183 24.2732L22.7159 19.0756C23.2304 18.5607 24.0649 18.5607 24.5787 19.0756C25.0933 19.5901 25.0933 20.4246 24.5787 20.9384Z",
  fill: "#3558C7",
  fillOpacity: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5788 20.9384L19.5391 25.9788V22.2521L22.716 19.0756C23.2305 18.5607 24.0649 18.5607 24.5788 19.0756C25.0933 19.5901 25.0933 20.4246 24.5788 20.9384Z",
  fill: "#0041BE"
});

function SvgReset3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset3);
export default __webpack_public_path__ + "static/media/reset3.49a6df50.svg";
export { ForwardRef as ReactComponent };